<template>
  <div>
    <status-module
      :appointment="appointment"
      class="mb-2"
      data-cy="statusModule"
    ></status-module>
    <scheduling-module
      :appointment="appointment"
      data-cy="schedulingModule"
    ></scheduling-module>
  </div>
</template>

<script>
import SchedulingModule from "../modules/Scheduling/SchedulingModule.vue";
import StatusModule from "../modules/Status/StatusModule.vue";
export default {
  components: {
    StatusModule,
    SchedulingModule
  },
  props: {
    appointment: {
      type: Object,
      default: null
    }
  }
};
</script>

<style lang="scss" scoped></style>
